// src/lib/taskRealtimeChannels.ts
//
// Realtime channel names for the task subscriptions.
//
// WHY THIS EXISTS. realtime-js `client.channel(name)` RETURNS THE EXISTING
// CHANNEL when one with the same topic is already registered. The app-wide
// toast listener (TaskNotificationListener, mounted in MainLayout) and the
// /tasks page list subscription (useTaskAssignmentsRealtime) both used
// "task-assignments-realtime", so:
//   * the second binding was attached to an already-subscribed channel and
//     never registered, and
//   * leaving /tasks ran removeChannel on the SHARED channel, killing the
//     app-wide listener until a full reload.
// Distinct, per-user names make the two independent.

/** Channel for the list page's cache-invalidation subscription. */
export function taskListChannelName(userId: string): string {
  return `task-list:${userId}`;
}

let toastInstance = 0;

/**
 * Channel for the app-wide new-task toast listener.
 *
 * Carries a per-mount sequence number as well as the user id: removeChannel
 * only drops a channel from the client's registry AFTER its unsubscribe
 * round-trip resolves, so a fast remount (mobile/desktop layout switch,
 * StrictMode) asking for the same name would be handed the dying channel.
 */
export function taskToastChannelName(userId: string): string {
  toastInstance += 1;
  return `task-toast:${userId}:${toastInstance}`;
}
